// Environment variables utility
import Constants from "expo-constants"

// Get API keys from Expo Constants
const EXPO_CONFIG = Constants.expoConfig?.extra || {}

// Google Maps API Key
export const GOOGLE_MAPS_API_KEY = EXPO_CONFIG.GOOGLE_MAPS_API_KEY || ""

// Weather API Key
export const TOMORROW_IO_API_KEY = EXPO_CONFIG.TOMORROW_IO_API_KEY || ""

// Check if we have valid API keys
export const hasValidGoogleMapsKey = GOOGLE_MAPS_API_KEY && GOOGLE_MAPS_API_KEY.length > 10
export const hasValidWeatherKey = TOMORROW_IO_API_KEY && TOMORROW_IO_API_KEY.length > 10

// Helper to check environment
export const isDevelopment = process.env.NODE_ENV === "development"

// Log available keys in development
if (isDevelopment) {
  console.log("Environment loaded:", {
    hasGoogleMapsKey: !!GOOGLE_MAPS_API_KEY,
    hasTomorrowIOKey: !!TOMORROW_IO_API_KEY,
  })
}

